import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Select from "react-select";
import LoadingSpinner from "../../../common/spinner/loading.component.jsx";
import Icon from "../../icon/icon.component.jsx";


const deleteIcon = <Icon value="trash" className="mr-1" />
const saveIcon = <Icon value="save" className="mr-1" />

const messages = defineMessages({
    "public": {
        id: "common.search_filter.visibilty_public",
        defaultMessage: "Shared",
    },
    "private": {
        id: "common.search_filter.visbility_private",
        defaultMessage: "Private",

    },
    "update_title": {
        id: "common.search_filter.saved_filter_modal.update_view_title",
        defaultMessage: "Edit view settings",
    },
    "create_title": {
        id: "common.search_filter.saved_filter_modal.create_view_title",
        defaultMessage: "Create a new saved view",
    }
})



const selectOptions = [
    {
        value: 'public',
        label:
            <FormattedMessage
                id="common.search_filter.saved_filter.filter_option_shared"
                defaultMessage="Shared"
            />
    },
    {
        value: 'private',
        label:
            <FormattedMessage
                id="common.search_filter.saved_filter.filter_option_private"
                defaultMessage="Private"
            />
    },
];


class SavedFilterModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterId: props.filterId,
            filterName: "",
            visibility: "public",
            filtersToUse: this.props.filtersToUse,
            listingType: this.props.listingType,
            filterExists: false,
            isDisabled: '',
            isLoading: true,
            view: this.props.view,
        }

        this.saveFilter = this.saveFilter.bind(this)
        this.onChangeVisibility = this.onChangeVisibility.bind(this)
        this.onChangeFilterName = this.onChangeFilterName.bind(this)
        this.updateFilter = this.updateFilter.bind(this)
        this.deleteFilter = this.deleteFilter.bind(this)
    }

    componentDidMount() {
        if (this.props.onSaveAsNew) {
            this.setState({
                filterName: '',
                isLoading: false,
                isDisabled: true,
            })
            this.saveFilter()
        }
        else if (this.state.filterId) {
            AppContext.getApiClient().get('/saved-filters/' + this.state.filterId).then(res => {
                this.setState({
                    visibility: res.attributes.visibility,
                    filterName: res.attributes.name,
                    isLoading: false,
                })
            })
            this.checkIfFilterExists()
        }
    }

    createFilterObject(filterContent) {
        let filterObject = {
            "attributes": {
                "name": this.state.filterName,
                "visibility": this.state.visibility,
                "listingType": this.state.listingType,
                "content": filterContent,
                "createdBy": this.props.userId,
                "view": this.props.view,
            },
            "id": this.state.filterId,
        }
        return filterObject;
    }

    //could potentially remove this? and instead just check if filterId is not empty
    checkIfFilterExists() {
        if (this.state.filterId) {
            this.setState({
                filterExists: true
            })
        }
    }

    deleteFilter() {
        AppContext.getApiClient().delete('/saved-filters/' + this.state.filterId).then(() => {
            this.setState({
                filterName: "",
                visibility: "",
                filtersToUse: "",
                view: { columns: [] }
            })
            var filterObject = this.createFilterObject(this.state.filtersToUse)
            this.props.onUpdatedSavedFilter(filterObject)
            this.props.onCloseModal()
        })
    }

    updateFilter() {
        if (this.state.filterName) {
            var filter = Base64.encode(JSON.stringify({
                filters: this.state.filtersToUse,
            }))

            AppContext.getApiClient().patch('/saved-filters/' + this.state.filterId, {
                name: this.state.filterName,
                visibility: this.state.visibility,
                listingType: this.state.listingType,
                content: filter,
                view: this.props.view,
            }).then(() => {
                var filterObject = this.createFilterObject(filter)
                this.props.onUpdatedSavedFilter(filterObject)
                this.props.onCloseModal()
            })
        }
    }

    saveFilter() {
        if (
            this.state.filterName
            && (Object.keys(this.state.filtersToUse).length > 0 || this.props.view)
            && this.state.listingType
        ) {
            var filter = Base64.encode(JSON.stringify({
                filters: this.state.filtersToUse,
            }))
            AppContext.getApiClient().post('/saved-filters', {
                name: this.state.filterName,
                visibility: this.state.visibility,
                listingType: this.state.listingType,
                content: filter,
                view: this.props.view,
            }).then(res => {
                var filterObject = {
                    "attributes": {
                        "name": this.state.filterName,
                        "visibility": this.state.visibility,
                        "listingType": this.state.listingType,
                        "content": filter,
                        "createdBy": this.props.userId,
                        "view": this.props.view,
                    },
                    "id": res.id,
                }
                this.props.onUpdatedSavedFilter(filterObject)
                this.props.onCloseModal()
            })
        }
    }

    onChangeVisibility(event) {
        if (event) {
            this.setState({
                visibility: event.value,
            });
        }
    }

    onChangeFilterName(e) {
        if (e.target.value) {
            this.setState({
                isDisabled: false,
                filterName: e.target.value
            })
        }
        else if (e.target.value === "") {
            this.setState({
                isDisabled: true,
                filterName: e.target.value,
            })
        }
    }

    render() {
        let title;
        let buttonGroup;
        if (this.state.filterExists) {
            title = this.props.intl.formatMessage(messages["update_title"])
            buttonGroup =
                <div className="btn-toolbar">
                    <button type="button" onClick={this.deleteFilter} className="btn btn-outline-danger mr-2">
                        {deleteIcon}
                        <FormattedMessage
                            id="common.search_filter.save_filter_modal.delete"
                            defaultMessage="Delete"
                        />
                    </button>
                    <button type="button" onClick={this.updateFilter} className={this.state.isDisabled ? "btn btn-outline-primary disabled" : "btn btn-outline-primary"}>
                        {saveIcon}
                        <FormattedMessage
                            id="common.search_filter.save_filter_modal.update"
                            defaultMessage="Update"
                        />
                    </button>

                </div>
        } else {
            title = this.props.intl.formatMessage(messages["create_title"])
            buttonGroup =
                <div>
                    <button type="button" onClick={this.saveFilter} className={this.state.isDisabled ? "btn btn-success disabled" : "btn btn-success"}>
                        {saveIcon}
                        <FormattedMessage
                            id="common.search_filter.save_filter_modal.save"
                            defaultMessage="Save"
                        />
                    </button>
                </div>
        }
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <div className="h5 modal-title">
                        <span>{title}</span>
                    </div>
                </div>
                <div className="modal-body overflow-visible">

                    {this.state.isLoading ?
                        <LoadingSpinner /> :

                        <form>
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                    <FormattedMessage
                                        id="common.search_filter.save_filter_modal.view_name"
                                        defaultMessage="View Name"
                                    />
                                </label>
                                <div className="col-sm-8">
                                    <input type="text" value={this.state.filterName} onChange={this.onChangeFilterName} className="form-control" placeholder="View Name" id="filterName" />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                    <FormattedMessage
                                        id="common.search_filter.save_filter_modal.visibility"
                                        defaultMessage="Visibility"
                                    />
                                </label>
                                <div className="col-sm-8">
                                    <Select
                                        clearable={false}
                                        defaultValue={selectOptions[0]}
                                        options={selectOptions}
                                        onChange={this.onChangeVisibility}
                                        value={this.state.visibility}
                                    />

                                </div>
                            </div>
                        </form>
                    }
                </div>
                <div className="modal-footer justify-content-between">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.onCloseModal}>
                        <FormattedMessage
                            id="template.sections.sort.modal.close_btn"
                            defaultMessage="Close"
                        />
                    </button>
                    {buttonGroup}
                </div>
            </div>
        );
    }
}
export default injectIntl(SavedFilterModal);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-menu/savedFilterModal.component.jsx